import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { SimpleFormGroupService } from '@shared/components/filters-bar/simple-form-group.service';
import { ExpandableResource } from '../expandable-resource';
import { DataCellFormatterPipe } from './data-cell-formatter.pipe';

@Component({
  /* tslint:disable */
  selector: '[miq-tree-data-row]',
  /* tslint:enable */
  templateUrl: './tree-data-row.component.html',
  styleUrls: ['./tree-data-row.component.scss'],
  standalone: false,
})
export class TreeDataRowComponent implements OnInit {
  @Input() row: ExpandableResource<any>;
  @Input() columns: any[];

  /**
   * prev: it sends the row snapshot
   * next: it sends the changed data (editable fields only)
   */
  @Output() rowChange = new EventEmitter<any>();
  @Output() toggle = new EventEmitter<any>();

  form: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private simpleFormGroupService: SimpleFormGroupService
  ) {}

  ngOnInit() {
    const dataTransformService = new DataCellFormatterPipe();
    const editableFields = this.columns
      .filter(({ editable }) => editable)
      .map(props => ({ ...props, value: dataTransformService.transform(this.row, props) }));
    const controls = this.simpleFormGroupService.makeGroup(editableFields);
    this.form = this.fb.group(controls);
  }

  clicked(row, col) {
    const { rowClick } = col;
    if (rowClick && !row.editMode) {
      return !row.isContainer ? rowClick(row) : this.toggle.emit(row);
    }
  }

  toggleRow(row) {
    return row.isContainer ? this.toggle.emit(row) : null;
  }

  submit() {
    return this.form.valid ? this.rowChange.emit({ prev: this.row, next: this.form.value }) : null;
  }
}
